import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, TextField, Button, IconButton, InputAdornment, Typography, Container, Grid } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import AlertError from '../Alerts/AlertError';
import { useAuth } from '../../contexts/AuthContext';
import carreteraImg from '../../assets/login/carretera.png';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const userData = await login(username, password);
      console.log('Datos del usuario:', userData);
      console.log('Datos del user:', user);
      // Ahora puedes acceder a los permisos y settings
      console.log('Permisos:', userData.userData?.perfil?.permisos);
      console.log('Settings:', userData.userData?.perfil?.setting);
      navigate('/search');
    } catch (error) {
      if (error.message === 'usuario inactivo') {
        setError('Esta cuenta de usuario no está activa, si desea reactivarla por favor póngase en contacto con nuestro centro de soporte enviando un e-mail a: soporte@smartreport.cl');
      } else {
        setError(error.message || 'Usuario o contraseña incorrectos');
      }
      setUsername('');
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh',
      background: '#f8f7fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12} md={8} sx={{ display: { xs: 'none', md: 'block' } }}>
            <Box
              sx={{
                height: '100%',
                borderRadius: '15px',
                overflow: 'hidden',
                background: '#f8f7fa'
              }}
            >
              <img
                src={carreteraImg}
                alt="Login background"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, boxShadow: 'none' }}>
              <Box sx={{ mb: 4, textAlign: 'center' }}>
                <img src="data:image/png;base64,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" alt="Logo" style={{ maxWidth: '200px' }} />
              </Box>
              <Typography variant="h4" sx={{ mb: 1, color: '#566a7f' }}>
                ¡Bienvenido! 👋
              </Typography>
              <Typography variant="body2" sx={{ mb: 4, color: '#697a8d' }}>
                Por favor inicia sesión en tu cuenta
              </Typography>

              <form onSubmit={handleLogin}>
                <TextField
                  fullWidth
                  label="Usuario"
                  variant="outlined"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Contraseña"
                  type={showPassword ? 'text' : 'password'}
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                  sx={{ mb: 2 }}
                >
                  {loading ? 'Cargando...' : 'Entrar'}
                </Button>
                <Button
                  fullWidth
                  variant="text"
                  color="primary"
                  onClick={() => navigate('/login/recover')}
                >
                  ¿Olvidaste tu contraseña?
                </Button>
              </form>
            </Card>
          </Grid>
        </Grid>
      </Container>
      {error && <AlertError message={error} onClose={() => setError('')} />}
    </Box>
  );
};

export default Login; 